export default __webpack_public_path__ + "static/media/loading_01-1.85fc2d42.gif";